import React from 'react';

import {
	DefaultTh,
	DefaultTr,
} from '@components';

function MeetingListTableTh(): JSX.Element {
	return (
		<DefaultTr>
			<DefaultTh width="60%" minWidth="500px">
				Название
			</DefaultTh>
			<DefaultTh width="16%" minWidth="200px">
				Дата проведения
			</DefaultTh>
			<DefaultTh width="12%" minWidth="200px">
				Длительность
			</DefaultTh>
			<DefaultTh width="12%" minWidth="130px">
				Статус
			</DefaultTh>
		</DefaultTr>
	)
}

export {MeetingListTableTh};